module.exports = __webpack_public_path__ + "img/step4b-fr@2x.27cd459f.webp";